import React from 'react';

import Home from '../Component/home';
import Menu from '../Component/menu';

import {useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import About from '../Component/about';
import Skill from '../Component/skill';
import '../App.css';
import Project from '../Component/project';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Contact from '../Component/contact';
function Main() {
  useEffect(()=>{
    AOS.init({duration:3000})
    },[]);
  return (
   
    
    <div className="App">
   
        <Menu>
         
          <div data-AOS="fade-up" className="main " id="menu" >
            <Home/>
            
          </div>
          <div className="main-about"  id="about">
            <About data-AOS="fade-left" />
            <Skill data-AOS="fade-right"  />
          </div>
          <div data-AOS="fade-right" className="main-project"  id="project">
            <Project/>
          </div>
          <div data-AOS="fade-up" className="main less-h">
            <Contact/>
          </div>
        </Menu>
    </div>
   
  );
}

export default Main;
